import o from "./ghl-ui.es1456.js";
import T from "./ghl-ui.es1416.js";
import f from "./ghl-ui.es1611.js";
function O(s) {
  T(1, arguments);
  var r = o(s), e = r.getUTCFullYear(), t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(e + 1, 0, 4), t.setUTCHours(0, 0, 0, 0);
  var u = f(t), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(e, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var i = f(a);
  return r.getTime() >= u.getTime() ? e + 1 : r.getTime() >= i.getTime() ? e : e - 1;
}
export {
  O as default
};
